import { useState, useEffect } from "react";
import { Navbar, Nav, Container, Col, Row } from "react-bootstrap";
import { HashLink } from 'react-router-hash-link';
import {
  BrowserRouter as Router
} from "react-router-dom";
import React from "react";

import logo from '../assets/img/LOGO.png';

export const NavBar = () => {

  const [activeLink, setActiveLink] = useState('ourServices');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const onUpdateActiveLink = (value: React.SetStateAction<string>) => {
    setActiveLink(value);
  }

  return (
   
      <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
        <Row className="align-items-center">
          <Col size={1} md={2}>
            <img className="logoImg"  src={logo} alt="Logo" />
          
          </Col>

          <Col md={3}>
            <span className="brand-name cen">MAG Institute Of Maritime Academy</span>
          </Col>
         
          <Col md="7">
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon" /> 
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="/" className="navbar-link">Home</Nav.Link>

              <Nav.Link href="/home#skills" className="navbar-link">About Us</Nav.Link>

              <Nav.Link href="/home#project" className="navbar-link">Our Services</Nav.Link>
            </Nav>
            <span className="navbar-text">
              {/* <div className="social-icon">
                <a href="#"><img src={navIcon1} alt="" /></a>
                <a href="#"><img src={navIcon2} alt="" /></a>
                <a href="#"><img src={navIcon3} alt="" /></a>
              </div> */}
              <a href="/ValidateCertificate">
                <button className="vvd pd10">
                  <span className="wrap">Online Certificate Validation</span>
                  </button>
              </a>
            </span>
            </Navbar.Collapse>
            </Col>
        </Row>
      </Navbar>  
   
  )
}
